import React from 'react'
import { InputText } from '../../atoms';
import { AutoComplete } from '../../../utils/utils.js'
import {Popup} from '../../organisms'
import { useRef } from 'react'; 

export function SearchRecipe (props) { 
  const ingRef =  useRef()
  React.useEffect(() => {
    const click = e => {
      if ( props.hidden && ingRef.current && !ingRef.current.contains(e.target) && !e.target.classList.contains('search-toggle') ) {
        props.hiddenClose()
      }
    }
    document.addEventListener("mousedown", click)
    return () => {
      document.removeEventListener("mousedown", click)
    }
  }, [props.hidden])

  return (
    <>  
      <input 
        type='text'
        autoComplete="off" 
        value={props.keyword || ''} 
        step='any'
        onChange={props.handleChangeInput} 
        placeholder='Начните вводить название или ингредиент'
        className = {`form__input font20Norm form__input_type_${props.name} ${props.error ? 'form__error' : ''}`} 
        name='search' 
        id='search' 
      /> 

    {props.choiceIngredient.length > 0 &&
      <span className='form__search_list'>
        {props.choiceIngredient.map((i, index)=> (
          <li key={index} className='ingredient__items font14Norm'><p className='ingredient__search font20Norm'>{i.name}</p> 
            <span onClick={()=> props.handleDelete(i._id)} className='gg-del s-size' />
          </li>
        )) }
      </span> 
    }
    <Popup isOpen={props.hidden} ref={ingRef} type='search-toggle'>
      {props.filtrMassiv.length > 0 ?
        props.filtrMassiv.map((item, index) => (
          <AutoComplete 
            key={index} 
            item={item} 
            onClick={()=>props.handleAutoText(item)} 
            name={props.name}
          />   
        )) 
      : 
        <div className='recipe_search'>
          <p className='gg-no-dish'></p> 
          <p className=' font20Nprm '>Ничего не найдено</p> 
        </div> 
      }
    </Popup>  
    <label> 
    <input 
        type='text'
        autoComplete="off" 
        value={props.userId || ''} 
        step='any'
        onChange={props.handleChangeInputId} 
        placeholder='Поиск по ID пользователя'
        className = {`form__input font20Norm form__input_type_${props.name} ${props.error ? 'form__error' : ''}`} 
        name='searchID' 
        id='searchID' 
      /> 
   </label>
 
    </>
  )
}

